// src/services/organizationAccessService.js - Simple version for your existing structure
import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

class OrganizationAccessService {
  async checkMembership(bookId, userId) {
    try {
      const memberDoc = await getDoc(doc(db, 'pb-books', bookId, 'pb-members', userId));
      return memberDoc.exists();
    } catch (error) {
      console.error('Error checking membership:', error);
      return false;
    }
  }

  async getMemberStatus(bookId, userId) {
    try {
      const memberDoc = await getDoc(doc(db, 'pb-books', bookId, 'pb-members', userId));
      return memberDoc.exists() ? memberDoc.data() : null;
    } catch (error) {
      console.error('Error getting member status:', error);
      return null;
    }
  }

  async checkOrganizationAccess(bookId, userId) {
    try {
      const memberStatus = await this.getMemberStatus(bookId, userId);
      
      if (!memberStatus) {
        return { hasAccess: false, reason: 'NOT_MEMBER' };
      }

      if (memberStatus.status === 'pending') {
        return { hasAccess: false, reason: 'PENDING_APPROVAL' };
      }

      if (memberStatus.status === 'active') {
        return { hasAccess: true, memberStatus };
      }

      return { hasAccess: false, reason: 'INACTIVE' };
    } catch (error) {
      return { hasAccess: false, reason: 'ERROR' };
    }
  }
}

export const organizationAccessService = new OrganizationAccessService();